import * as api from '../../api/equityFinder/dataload';
import { makeApiActionCreatorV3 } from '../utils';

export const LAST_DATE_FETCH_START = 'DATALOAD/LAST_DATE_FETCH_START';
export const LAST_DATE_FETCH_SUCCESS = 'DATALOAD/LAST_DATE_FETCH_SUCCESS';
export const LAST_DATE_FETCH_ERROR = 'DATALOAD/LAST_DATE_FETCH_ERROR';

export const DATA_IMPORT_START = 'DATALOAD/DATA_IMPORT_START';
export const DATA_IMPORT_SUCCESS = 'DATALOAD/DATA_IMPORT_SUCCESS';
export const DATA_IMPORT_ERROR = 'DATALOAD/DATA_IMPORT_ERROR';

export const DATA_FETCH_START = 'DATALOAD/DATA_FETCH_START';
export const DATA_FETCH_SUCCESS = 'DATALOAD/DATA_FETCH_SUCCESS';
export const DATA_FETCH_ERROR = 'DATALOAD/DATA_FETCH_ERROR';

export const fetchLastDate = makeApiActionCreatorV3(
  api.fetchLastDate,
  LAST_DATE_FETCH_START,
  LAST_DATE_FETCH_SUCCESS,
  LAST_DATE_FETCH_ERROR,
);
export const importData = makeApiActionCreatorV3(
  api.importData,
  DATA_IMPORT_START,
  DATA_IMPORT_SUCCESS,
  DATA_IMPORT_ERROR,
);
export const fetchData = makeApiActionCreatorV3(
  api.fetchData,
  DATA_FETCH_START,
  DATA_FETCH_SUCCESS,
  DATA_FETCH_ERROR,
);
